import { z } from 'zod';
import { IAssetCategoryId } from './IAssetCategory';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';
import { IRealEstate } from '../IRealEstate';

export const RealEstateAssetVersion = {
  Initial: 1,
} as const;

export type RealEstateAssetVersion =
  (typeof RealEstateAssetVersion)[keyof typeof RealEstateAssetVersion];

export const RealEstateSchema = z.custom<IRealEstate>();

export const RealEstateAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.RealEstate),
  z.literal(IAssetCategoryId.RealEstate),
  z.literal(RealEstateAssetVersion.Initial).optional(),
  RealEstateSchema
);

export type IRealEstateAsset = z.infer<typeof RealEstateAssetSchema>;
